import { render, staticRenderFns } from "./ContMyDatasourcesComponent.vue?vue&type=template&id=2d34b44d&scoped=true&lang=pug"
import script from "./ContMyDatasourcesComponent.vue?vue&type=script&lang=js"
export * from "./ContMyDatasourcesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d34b44d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d34b44d')) {
      api.createRecord('2d34b44d', component.options)
    } else {
      api.reload('2d34b44d', component.options)
    }
    module.hot.accept("./ContMyDatasourcesComponent.vue?vue&type=template&id=2d34b44d&scoped=true&lang=pug", function () {
      api.rerender('2d34b44d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/my_objects/components/ContMyDatasourcesComponent.vue"
export default component.exports